/* Video con botón de sonido.
   - Se descarga al acercarse a la pantalla y arranca SIN sonido (así nunca suena solo).
   - El botón "Activar sonido" lo enciende solo si la persona quiere; al salir de pantalla se pausa y vuelve a quedar en silencio.
   Funciona con cualquier <div data-mg-video> que tenga un <video> y un <button data-sound-toggle> adentro. */
(function () {
  'use strict';
  if (window.__mgVideo) return;
  window.__mgVideo = true;
  Array.prototype.forEach.call(document.querySelectorAll('[data-mg-video]'), function (box) {
    var v = box.querySelector('video');
    if (!v) return;
    var btn = box.querySelector('[data-sound-toggle]');
    var txt = btn && btn.querySelector('.mg-sound__txt');
    var labelOn = (btn && btn.getAttribute('data-label-on')) || 'Silenciar';
    var labelOff = (btn && btn.getAttribute('data-label-off')) || 'Activar sonido';
    var started = false, wantPlay = false;

    var setSound = function (on) {
      v.muted = !on;
      if (on) v.volume = 1;
      if (!btn) return;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? labelOn : labelOff);
      if (txt) txt.textContent = on ? labelOn : labelOff;
    };
    var play = function () {
      if (!started) { started = true; v.load(); }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };

    if (btn) btn.addEventListener('click', function () {
      setSound(v.muted);
      if (v.paused) play();
    });
    if (!('IntersectionObserver' in window)) { play(); return; }

    // 1) empieza a descargarse un poco antes de llegar
    var near = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { near.disconnect(); if (!started) { started = true; v.load(); } }
    }, { rootMargin: '300px 0px' });
    near.observe(v);
    // 2) reproduce cuando se ve; al salir de pantalla se pausa y se vuelve a silenciar
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { wantPlay = true; play(); }
      else { wantPlay = false; v.pause(); setSound(false); }
    }, { threshold: 0.3 }).observe(v);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { v.pause(); setSound(false); } else if (wantPlay) play();
    });
  });
})();
